<template>
  <div class="home">
    <!--<img alt="Vue logo" src="../assets/logo.png" />-->
    <div class="currentUserInfo">
      <h1>Welcome, {{ user.username }}</h1>
      <p>Your email address is: {{ user.attributes.email }}</p>
      <p>Your Cognito ID is: {{ user.attributes.sub }}</p>
    </div>
    <CheckRegistration />
    <ViewUserRegistration />
    <CurrentUserInfo />
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import { Auth } from "aws-amplify";

// @ is an alias to /src
// import the components
//import CurrentUser from "@/components/CurrentUser.vue";
//import HelloWorld from "@/components/HelloWorld.vue";
import ViewUserRegistration from "@/components/ViewUserRegistration.vue";
import CurrentUserInfo from "@/components/CurrentUserInfo.vue";
import CheckRegistration from "@/components/CheckRegistration.vue";

export default {
  name: "Home",
  components: {
    ViewUserRegistration,
    CurrentUserInfo,
    CheckRegistration
  },
  data() {
    return {
      user: {}
    };
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then(user => {
        this.user = user;
        this.$store.commit("changeCurrentUserName", user.username);
        this.$store.commit("changeCurrentUserEmail", user.attributes.email);
        this.$store.commit("changeCurrentUserSub", user.attributes.sub);
      })
      .catch(() => console.log("not signed in..."));
  }
};
</script>
